import { type ILayerProps, type ITextLayerProps, type ListStyle } from '@/version-types';

/**
 * 判断列表样式是否为普通字符 marker。
 *
 * @param listStyle - ListStyle | ''，图层列表样式。
 * @returns boolean，是普通字符 marker 时返回 true。
 */
export const isCharListStyle = (listStyle: ListStyle | ''): listStyle is Exclude<ListStyle, 'custom'> => {
    return Boolean(listStyle && listStyle !== 'custom');
};

/**
 * 统计原始文本中需要绘制列表 marker 的段落数量。
 *
 * 该数量不依赖引擎软换行结果，因此可以在 snapshot layout 前用于测量 fixed-width 正文约束。
 *
 * @param layer - ILayerProps，当前文本图层。
 * @returns number，原始文本段落数量；非列表或空文本返回 0。
 */
export const countListParagraphs = (layer: ILayerProps): number => {
    const data = layer.data as ITextLayerProps;
    if (!data.listStyle) return 0;

    const text = data.text;
    if (!text) return 0;

    return text.split(/\r\n|\r|\n/).length;
};
